<template>
  <div class="mt-6 md:mt-10">
    <ul id="grid" class="clear flex justify-center">
      <hexagon-grid-element
        v-for="feature of features"
        :feature="feature"
        :is-selected="featureIndex(feature.key) >= 0"
        :key="feature.key"
        @onClick="onFeatureClick"
      />
    </ul>
  </div>
</template>

<script>
import HexagonGridElement from "@/components/calculator-steps/utils/HexagonGridElement";

export default {
  name: "StepFiveHexagonGrid",
  components: {
    HexagonGridElement,
  },
  data: () => ({
    features: [
      { text: "SEO", key: "seo", description: "Koduleht nähtavaks otsingumootorites" },
      { text: "ADWORDS", key: "adwords", description: "Google reklaamkampaania ülespanek" },
      { text: "ANALYTICS", key: "analytics", description: "Kodulehe statistika" },
    ],
    selected: [],
  }),
  methods: {
    featureIndex(featureKey) {
      return this.selected.findIndex((el) => el === featureKey);
    },
    onFeatureClick(featureKey) {
      const featureIndex = this.featureIndex(featureKey);
      if (featureIndex >= 0) {
        this.selected.splice(featureIndex, 1);
      } else {
        this.selected.push(featureKey);
      }
      this.$store.dispatch("prices/GOOGLE", this.selected);
    },
  },
};
</script>

<style>
</style>
